<template>
  <div
    v-if="plan.id"
    class="col-lg-4 box"
    :class="{ 'Selected': isSelected }"
    :id="'plan-'+plan.id"
  >
    <h3>{{ plan.name }}</h3>
    <h4>${{ plan.price.quantity }}<small v-if="plan.meta.SUPPORT_FEE!='-'">+</small><span>{{
        $t('Monthly')
      }}</span></h4>
    <ul role="list-items" class="list-group">
      <li class="list-group-item d-flex justify-content-between align-items-center">
        {{ $t('Containsthenumberofdomains') }}
        <span class="badge badge-success badge-pill"> {{ plan.meta.DOMAIN }} </span>
      </li>
      <li class="list-group-item d-flex justify-content-between align-items-center">
        {{ $t('Upgradabledomainnamelimit') }}
        <span class="badge badge-success badge-pill"
              v-if="plan.meta.DOMAIN_UP > plan.meta.DOMAIN">{{ $t('Upto', [plan.meta.DOMAIN_UP]) }}</span>
        <span class="badge badge-danger badge-pill" v-else>{{ $t('no') }}</span>
      </li>
      <li class="list-group-item d-flex justify-content-between align-items-center">
        {{ $t('CCtrafficattackprevention') }} <span
        class="badge badge-primary badge-pill"> {{ plan.meta.CC }}</span></li>
      <li class="list-group-item d-flex justify-content-between align-items-center">
        {{ $t('DDOSattackprevention') }} <span class="badge badge-primary badge-pill"> {{
          plan.meta.DDOS
        }}</span></li>
      <li class="list-group-item d-flex justify-content-between align-items-center">
        {{ $t('Genericdomainname') }} <span
        class="badge badge-primary badge-pill"> {{ $t(plan.meta.WILDDOMAIN) }} </span></li>
      <li class="list-group-item d-flex justify-content-between align-items-center">{{ $t('Traffic') }}
        <span class="badge badge-primary badge-pill"> {{ plan.meta.TRAFFIC }} </span></li>
      <!-- <li class="list-group-item d-flex justify-content-between align-items-center"> {{ $t('FreeTraffic') }} <span class="badge badge-primary badge-pill">{{ plan.meta.EXTRA_TRAFFIC }}</span></li> -->
      <li class="list-group-item d-flex justify-content-between align-items-center"> IPV6 <span
        class="badge badge-pill"
        :class="{'badge-primary': plan.meta.IPV6 === 'yes', 'badge-danger': plan.meta.IPV6 === 'no'}"> {{
          plan.meta.IPV6
        }}</span></li>
      <li class="list-group-item d-flex justify-content-between align-items-center">
        {{ $t('ServiceSupport') }} <span class="badge badge-primary badge-pill"> {{
          plan.meta.SUPPORT
        }}</span></li>
      <li class="list-group-item d-flex justify-content-between align-items-center"> {{
          $t('SupportFee')
        }} <span class="badge badge-success badge-pill"> {{ $t(plan.meta.SUPPORT_FEE) }}</span></li>
    </ul>

    <a class="btn-buy" @click="$emit('select', plan)">
      {{ $t('Select') }}
    </a>
  </div>
</template>
<script>
export default {
  name: "PackageCard",
  props: {
    plan: {
      type: Object,
      required: true
    },
    isSelected: {
      type: Boolean,
      default: false
    }
  },
  emits: ['select'],
}
</script>